import { Modal } from "antd";
import { useEffect, useState } from "react";
import successIcon from "assets/successIcon.png";
import errorIcon from "assets/errorIcon.png";
import styled from "@emotion/styled";
import { DialogStatus } from "./contant";
import { LabelType } from "screens/register/page-header";
import { getLanguage } from "auth-provider";
import "./customize.css";
import { RechargeType } from "types/joinAsMemberMode";

export const DialogResult = (props: {
  status: string;
  rechargeType: RechargeType;
  changeStatus: (val: string) => void;
  successCallback: () => void;
}) => {
  const lang = getLanguage() as LabelType;

  const [isSuccess, setIsSuccess] = useState(false);
  useEffect(() => {
    setIsSuccess(props.status === "success");
  }, [props.status]);

  const handleOnOk = () => {
    if (isSuccess) {
      props.successCallback();
    }
    props.changeStatus("");
  };

  return (
    <>
      <Modal
        title={null}
        closable={false}
        visible={!!props.status}
        footer={null}
        bodyStyle={{ color: "red" }}
        className={"cur-model"}
      >
        {isSuccess ? (
          <>
            {
              props.rechargeType === RechargeType.normal_gift_card_recharge && <Wrapper>
                <StatusIcon src={successIcon} />
                <StatusTxt>{DialogStatus.success.pay[lang]}</StatusTxt>
                <StatusTip>{DialogStatus.success.payTip[lang]}</StatusTip>
                <ConfirmBtn onClick={() => handleOnOk()}>
                  {DialogStatus.confirm[lang]}
                </ConfirmBtn>
              </Wrapper>
            }
            {
              props.rechargeType === RechargeType.join_member_annual_fee && <Wrapper>
                <StatusIcon src={successIcon} />
                <StatusTxt>{DialogStatus.annual_success.pay[lang]}</StatusTxt>
                <StatusTip>{DialogStatus.success.payTip[lang]}</StatusTip>
                <ConfirmBtn onClick={() => handleOnOk()}>
                  {DialogStatus.gotcha[lang]}
                </ConfirmBtn>
              </Wrapper>
            }
            {
              props.rechargeType === RechargeType.join_member_recharge_fee && <Wrapper>
                <StatusIcon src={successIcon} />
                <StatusTxt>{DialogStatus.recharge_join_success.pay[lang]}</StatusTxt>
                <StatusTip>{DialogStatus.success.payTip[lang]}</StatusTip>
                <ConfirmBtn onClick={() => handleOnOk()}>
                  {DialogStatus.gotcha[lang]}
                </ConfirmBtn>
              </Wrapper>
            }
          </>
        ) : (
          <>
            <Wrapper>
              <StatusIcon src={errorIcon} />
              <StatusTxt>{DialogStatus.error.pay[lang]}</StatusTxt>
              <StatusTip>{DialogStatus.error.payTip[lang]}</StatusTip>
              <ConfirmBtn onClick={() => handleOnOk()}>
                {DialogStatus.confirm[lang]}
              </ConfirmBtn>
            </Wrapper>
          </>
        )}
      </Modal>
    </>
  );
};

const Wrapper = styled.div`
  text-align: center;
`;

const StatusIcon = styled.img`
  width: 10.8rem;
  height: 10.8rem;
  margin: 0 auto 1.6rem auto;
`;

const StatusTxt = styled.div`
  color: #1d1b2e;
  font-weight: 600;
  font-size: 2.4rem;
  margin: 0 auto 0.4rem auto;
  line-height:normal;
`;

const StatusTip = styled.div`
  color: #1d1b2e;
  font-weight: 300;
  font-size: 1.4rem;
  margin: 0 auto 2.4rem auto;
`;

const ConfirmBtn = styled.div`
  height: 4.4rem;
  width: 17rem;
  border-radius: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1d1b2e;
  color: #fff;
  font-size: 1.8rem;
  font-weight: 600;
  margin: auto;
`;
